import {
    CREATE_REGION_START,
    CREATE_REGION_SUCCESS,
    CREATE_REGION_FAILED,
    FETCH_REGIONS_START,
    FETCH_REGIONS_SUCCESS,
    FETCH_REGIONS_FAILED,
    CLEAR_REGION_ERROR,
    UPDATE_REGION_START,
    UPDATE_REGION_SUCCESS,
    UPDATE_REGION_FAIL,
    DELETE_REGION_START,
    DELETE_REGION_SUCCESS,
    DELETE_REGION_FAIL,
    REMOVE_BROKER_START,
    REMOVE_BROKER_SUCCESS,
    REMOVE_BROKER_FAIL,
    REMOVE_REGION_START,
    REMOVE_REGION_SUCCESS,
    REMOVE_REGION_FAIL,
    REMOVE_AREA_START,
    REMOVE_AREA_FAIL,
    REMOVE_AREA_SUCCESS,


FETCH_BROKER_REGIONS_START,
FETCH_BROKER_REGIONS_SUCCESS,
FETCH_BROKER_REGIONS_FAILED

} from "../store/types";

const INITIAL_STATE = {
    regions: [],
    currentBrokerRegions: [],
    currentRegion: null,
    completed: false,
    loading: false,
    success: false,
    error: {
        flag: false,
        msg: null,
    },
};

export const regionreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_REGION_START:
            return {
                ...state,
                loading: true,
                completed: false,
                success: false,
            };


case FETCH_BROKER_REGIONS_START:
    return {
        ...state,
        loading: true,
        completed: false,
        success: false,
    };



   
    case FETCH_BROKER_REGIONS_SUCCESS:
        return {
            ...state,
            loading: false,
            currentBrokerRegions: action.payload,
        };


    case FETCH_BROKER_REGIONS_FAILED:
        return {
            ...state,
            loading: false,
            error: {
                flag: true,
                msg: action.payload,
            },
        };

    case CREATE_REGION_SUCCESS:
            return {
                ...state,
                loading: false,
                completed: true,
                success: true,
                regions: [...state.regions, action.payload],
                currentRegion: action.payload,
            };

        case CREATE_REGION_FAILED:
            return {
                ...state,
                loading: false,
                completed: true,
                success: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case FETCH_REGIONS_START:
            return {
                ...state,
                loading: true,
                completed: false,
                success: false,
            };

        case FETCH_REGIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                regions: action.payload,
            };

        case FETCH_REGIONS_FAILED:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case CLEAR_REGION_ERROR:
            return {
                ...state,
                completed: false,
                loading: false,
                success: false,
                error: {
                    flag: false,
                    msg: null,
                },
            };

        case UPDATE_REGION_START:
            return {
                ...state,
                loading: true,
                error: null, // Reset error on new update attempt
            };

        case UPDATE_REGION_SUCCESS:
            return {
                ...state,
                loading: false,
                regions: state.regions.map((region) =>
                    region.regionId === action.payload.regionId
                        ? { ...region, ...action.payload }
                        : region
                ),
                error: null, 
            };

        case UPDATE_REGION_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case DELETE_REGION_START:
            return {
                ...state,
                loading: true,
                error: null, 
            };

        case DELETE_REGION_SUCCESS:
            return {
                ...state,
                loading: false,
                regions: region?.regionId ? state.regions.filter(
                    (region) => region?.regionId !== action.payload.regionId
                ) : regions,
                error: null,
            };

        case DELETE_REGION_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };
            case REMOVE_AREA_START:
            return {
                ...state,
                loading: true,
                error: null, 
            };

        case REMOVE_AREA_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };

        case REMOVE_AREA_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };
            case REMOVE_REGION_START:
            return {
                ...state,
                loading: true,
                error: null, 
            };

        case REMOVE_REGION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };

        case REMOVE_REGION_FAIL:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        default:
            return state;
    }
};
